import { createAction } from '../../utils/action-helpers';

export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const updateQuestion = createAction(UPDATE_QUESTION);

export const RESET_QUESTIONS = 'RESET_QUESTIONS';
export const resetQuestions = createAction(RESET_QUESTIONS);
